/* global BigInt */
import * as React from 'react';
import { multiMint } from '../../multiMint';
import { MintWrite } from './MintWrite';

export function MintList(props) {
  const [config, setConfig] = React.useState(null);

  React.useEffect(() => {
    let qty = props.cart.length;
    if (qty) {
      let newConfig = {
        address: multiMint.addr,
        abi: multiMint.abi,
        functionName: 'mintList',
        args: [props.cart],
        value:
          typeof props.value === 'bigint'
            ? props.value
            : BigInt(props.value || 0),
      };
      setConfig(newConfig);
    } else {
      setConfig(null);
    }
  }, [props.cart, props.total, props.connected, props.value]);

  return (
    <>
      {config ? (
        <MintWrite
          config={config}
          value={props.value}
          cart={props.cart}
          eth={props.eth}
          resetCart={props.resetCart}
        />
      ) : null}
    </>
  );
}
